import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CHIP}/v3/networks`;

async function create(payload) {
	try {
		const requestPayload = {
			NetworkName: payload?.networkName ?? payload?.NetworkName ?? "",
			ChipSupplierId: payload?.chipSupplierId ?? payload?.ChipSupplierId ?? 0,
		};

		let response = await api.post(basePath, JSON.stringify(requestPayload));
		let treated = errorHandling.handleResponse(response, "networkService.create");
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "networkService.create");
		return {
			error: true,
			status: error?.response?.status,
			message: errorHandling.stripProcedurePrefix(error?.response?.data?.message),
			friendlyMessage: error?.response?.data?.friendlyMessage,
		};
	}
}

async function update(payload) {
	try {
		const requestPayload = {
			NetworkId: payload?.networkId ?? payload?.NetworkId ?? payload?.id ?? 0,
			NetworkName: payload?.networkName ?? payload?.NetworkName ?? "",
			ChipSupplierId: payload?.chipSupplierId ?? payload?.ChipSupplierId ?? 0,
		};

		let response = await api.put(basePath, JSON.stringify(requestPayload));
		let treated = errorHandling.handleResponse(response, "networkService.update");
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "networkService.update");
		return {
			error: true,
			status: error?.response?.status,
			message: errorHandling.stripProcedurePrefix(error?.response?.data?.message),
			friendlyMessage: error?.response?.data?.friendlyMessage,
		};
	}
}

async function save(payload) {
	if (payload.id > 0) {
		const updated = await update(payload);

		if (typeof updated === "number") {
			return updated;
		}

		// Erro do backend (ex.: operadora já cadastrada para o fornecedor) —
		// propaga pra quem chamou em vez de virar um id nulo silencioso.
		if (updated?.error) {
			return updated;
		}

		const updatedId =
			updated?.NetworkId ??
			updated?.networkId ??
			updated?.id ??
			updated?.resourceId ??
			payload?.id ??
			null;

		return updatedId;
	}

	const created = await create(payload);

	if (typeof created === "number") {
		return created;
	}

	if (created?.error) {
		return created;
	}

	const createdId =
		created?.NetworkId ??
		created?.networkId ??
		created?.id ??
		created?.resourceId ??
		null;

	return createdId;
}

async function list(payload = {}) {
	try {
		const queryParams = new URLSearchParams();

		const networkId = payload?.NetworkId ?? payload?.networkId ?? payload?.id;
		const chipSupplierId =
			payload?.ChipSupplierId ?? payload?.chipSupplierId;
		const active = payload?.Active ?? payload?.active ?? "S";

		if (networkId !== undefined && networkId !== null && networkId !== "") {
			queryParams.append("NetworkId", networkId);
		}

		if (
			chipSupplierId !== undefined &&
			chipSupplierId !== null &&
			chipSupplierId !== ""
		) {
			queryParams.append("ChipSupplierId", chipSupplierId);
		}

		queryParams.append("Active", active);

		const queryString = queryParams.toString();
		const url = queryString ? `${basePath}?${queryString}` : basePath;

		let response = await api.get(url);
		let treated = errorHandling.handleResponse(response, "networkService.list");
		if (treated) {
			return treated;
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "networkService.list");
		return null;
	}
}

async function remove(networkId) {
	try {
		let response = await api.delete(`${basePath}/${networkId}`);
		let treated = errorHandling.handleResponse(response, "networkService.remove");
		if (treated) {
			if (typeof treated === "number") {
				return treated;
			}

			return (
				treated?.NetworkId ??
				treated?.networkId ??
				treated?.id ??
				treated?.resourceId ??
				null
			);
		}
		return null;
	} catch (error) {
		errorHandling.cathError(error, "networkService.remove");
		return null;
	}
}

export const networkService = {
	list,
	save,
	update,
	remove,
};
